import React from "react";

export default function UnmappedTag() {
  return (
    <span
      style={{
        padding: "2px 8px",
        border: "1px solid lightgrey",
        borderRadius: "5px",
        fontSize: "10px",
        fontWeight: "bold",
      }}
    >
      Unmapped
    </span>
  );
}